// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603300033/js/" + chunkId + "." + {"44":"694c8aaf","225":"ef701050","481":"8f6d6ed4","486":"5be2ac00","770":"445f3331"}[chunkId] + ".0.2187809363607498.chunk.js";
};